import React from 'react';
import { Typography, Box } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const NoAlertsDisplay = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 6,
        px: 2,
        textAlign: 'center',
      }}
    >
      <CheckCircleOutlineIcon
        sx={{
          fontSize: 64,
          color: 'success.main',
          opacity: 0.5,
          mb: 2,
        }}
      />
      <Typography variant="h6" color="textPrimary" sx={{ mb: 0.5, fontWeight: 500 }}>
        All caught up
      </Typography>
      <Typography variant="body2" color="textSecondary">
        No new notifications at this time
      </Typography>
    </Box>
  );
};

export default NoAlertsDisplay;
